<div
  class="flex h-full items-center justify-between pl-[10px] pr-[4px]"
  (click)="onDropdown()"
  [ngClass]="{ 'cursor-pointer': !disabled }"
  [auxTooltip]="disabled ? msg : ''"
  [auxTooltipPositions]="topLevelTooltipPositions"
>
  @if (!selectedCategoryName) {
    <div class="truncate">Select and Manage Categories</div>
  }
  @if (selectedCategoryName) {
    <div
      class="truncate"
      #cat
      [auxTooltip]="cat.offsetWidth < cat.scrollWidth && !disabled ? selectedCategoryName : ''"
      [auxTooltipPositions]="categoryTooltipPositions"
    >
      {{ selectedCategoryName }}
    </div>
  }
  <aux-icon class="flex-shrink-0" name="CaretDownFilled" />
</div>
<div #trigger="cdkOverlayOrigin" cdkOverlayOrigin></div>

<ng-template
  cdkConnectedOverlay
  class="border-solid border-aux-gray-dark-100"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayOpen]="dropdownOpened"
  (detach)="dropdownOpened = false"
  (backdropClick)="dropdownOpened = false"
>
  <div
    (auxClickOutside)="dropdownOpened = false"
    [skipInitial]="isOpenedByDefault"
    class="ml-[-1px] rounded-b-[4px] border bg-white px-[8px] py-3"
    style="box-shadow: 0 5px 3px 0 #696f8e59"
    [ngStyle]="{
      width: trigger.elementRef.nativeElement.clientWidth + 1.5 + 'px',
    }"
  >
    <div class="h-[32px] w-full">
      <aux-input
        [(ngModel)]="filterText"
        (ngModelChange)="onFilter()"
        icon="Search"
        iconPosition="left"
        hotKey="/"
        inputClassName="text-aux-gray-dark-100 focus-within:text-aux-gray-dark-100 rounded-[4px] placeholder:text-aux-gray-dark-100 !placeholder:not-italic"
        iconClassName="text-aux-gray-dark-100 focus-within:text-aux-gray-dark-100"
        placeholder="Search"
      />
    </div>
    <div class="mt-[10px] h-[200px] w-full snap-y overflow-auto">
      @for (option of filteredCategories; track trackByFn($index, option)) {
        <aux-be-inline-category-option
          [option]="option"
          [categories]="categories"
          [isSelected]="isSelected(option)"
          (selectOptionEmit)="onDropdownSelected(option)"
          (addCategoryEmit)="onDropdownAdd($event, option)"
          (editCategoryEmit)="onDropdownEdit($event, option)"
        />
      }
    </div>
  </div>
</ng-template>
